/**
 * TutorTabLayout — ce qui entoure la page d'un onglet du tuteur : le fond du thème (la lueur au teal
 * sur l'accueil seulement, décidé le 28/10) et l'en-tête de l'espace. Calque de `StudentTabLayout`.
 */
import React from "react"

import { ScreenBackground } from "../../../../../design-system"
import { TutorShellHeader } from "./TutorShellHeader"

export type TutorTabLayoutProps = {
    /** L'onglet est l'accueil : la lueur. */
    home?: boolean
    children: React.ReactNode
}

export function TutorTabLayout(props: TutorTabLayoutProps) {
    const { home = false, children } = props

    return (
        <ScreenBackground glow={home}>
            <TutorShellHeader />
            {children}
        </ScreenBackground>
    )
}
